import { render, staticRenderFns } from "./StoreOptionsTab.vue?vue&type=template&id=3dc058dc&scoped=true&"
import script from "./StoreOptionsTab.vue?vue&type=script&lang=js&"
export * from "./StoreOptionsTab.vue?vue&type=script&lang=js&"
import style0 from "./StoreOptionsTab.vue?vue&type=style&index=0&id=3dc058dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc058dc",
  null
  
)

export default component.exports